// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"c431d646","244":"9aa6a89e","341":"63aed435","445":"b98d7559","624":"bfaaa6e6","857":"6f0b8489"}[chunkId] + ".chunk.js";
};